export default "__VITE_ASSET__dHSaDMqS__"